import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssLabelComponent } from '../label/label.component';

@Component({
  selector: 'umss-vertical-field',
  standalone: true,
  imports: [CommonModule, UmssLabelComponent],
  templateUrl: './vertical-field.component.html',
  styleUrls: ['./vertical-field.component.scss']
})
export class UmssVerticalFieldComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** Content props */
  @Input() label: string = '';
  @Input() htmlFor?: string;
  @Input() helperText?: string;
  @Input() errorMessage?: string;

  /** State props */
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() error: boolean = false;
}
